module.exports = __webpack_public_path__ + "img/265.clean_shop_floor.d5f8918d.svg";